module.exports = __webpack_public_path__ + "static/media/newLife2.79411899.jpg";